import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { getCabinetRouteForUser } from '@/lib/roleRoutes';
import { routes } from '@/lib/routes';

/** `/app` is not a real workspace — send the user to their primary role cabinet. */
const CabinetRedirect = () => {
  const { user } = useAuth();
  if (!user) return <Navigate to={routes.login} replace />;
  return <Navigate to={getCabinetRouteForUser(user)} replace />;
};

export default CabinetRedirect;
